import { giphyBlack, giphyDarkCharcoal, giphyLightGrey, giphyLightestGrey } from '@giphy/colors'
import { ReactNode, useContext } from 'react'
import { ControlSize } from 'types'
import { CopilotContext } from '../../context'
import { CopilotAlertContext } from '../../contexts/alert'
import { CopilotDropdownContext } from '../../contexts/dropdown'
import { useLabel } from '../hooks/use-label'
import { Button, DropdownButton, Label, Text } from './style'

type Props = {
    children?: ReactNode
    className?: string
    color?: string
    size: ControlSize
}

const CopilotDropdownButton = ({ children, className, color = giphyDarkCharcoal, size }: Props) => {
    const { activePresetId, hasChanges, activatePreset, resetPreset } = useContext(CopilotContext)
    const { isDropdownOpen, closeDropdown, openDropdown } = useContext(CopilotDropdownContext)
    const { showAlert } = useContext(CopilotAlertContext)
    const label = useLabel()
    const labelColor = activePresetId ? giphyLightestGrey : giphyLightGrey
    const showButton = activePresetId || hasChanges

    async function onButtonClick() {
        if (activePresetId && hasChanges) {
            await showAlert('revert')
            activatePreset(activePresetId)
        } else {
            await showAlert('reset')
            resetPreset()
        }
    }

    function onToggle(open: boolean) {
        open ? openDropdown() : closeDropdown()
    }

    return (
        <DropdownButton
            className={className}
            color={color}
            dropdownOptions={{ color: giphyBlack, width: 320 }}
            isOpen={isDropdownOpen}
            label={
                <Label>
                    <Text $size={size} style={{ color: labelColor }} onClick={() => onToggle(!isDropdownOpen)}>
                        <span>{label}</span>
                    </Text>
                    {showButton && (
                        <Button
                            color="transparent"
                            icon={hasChanges ? 'reset' : 'close'}
                            iconColor={giphyLightGrey}
                            iconScale={0.6}
                            size={size}
                            onClick={onButtonClick}
                        />
                    )}
                </Label>
            }
            labelStyle={{ padding: 0 }}
            size={size}
            triggerMode="arrow-only"
            onToggle={onToggle}
        >
            {children}
        </DropdownButton>
    )
}

export default CopilotDropdownButton
